module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"discount":"Discount","current":"Current","perMonth":"per month","every":"every","months":"months | month | months","addDiscount":"Add a discount"}}')
  delete Component.options._Ctor
}
